import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getImage } from "../Utils/image_helper";

export const PremiumFeatureOnlyModal = ({ isOpen, onClose, featureName }) => {
    const navigate = useNavigate();

    return (
        <Modal show={isOpen} onHide={onClose} centered dialogClassName="wide-modal">
            <div className="text-center px-3 py-4">
                <Modal.Header closeButton className="border-0 justify-content-center pb-1" />

                <Modal.Body className="text-muted px-4 py-0">
                    <div
                        className="d-flex justify-content-center align-items-center mb-4"
                        style={{
                            background: `url(${getImage("gradient")})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: "50%",
                            width: 100,
                            height: 100,
                            margin: "0 auto",
                            boxShadow: "0 8px 30px rgba(0,0,0,0.05)",
                            marginBottom: 20
                        }}
                    >
                        <i className="fas fa-crown" style={{ fontSize: "40px", color: "gold" }}></i>
                    </div>

                    <h5 className="fw-bold text-secondary-light mb-3">
                        Unlock <span className="text-primary">{featureName}</span>
                    </h5>

                    <p className="mb-4 px-2 text-secondary-light">
                        This feature is available with our <strong>Premium Plan</strong>.
                        Upgrade now to access <strong>{featureName}</strong> and enjoy a full suite of powerful tools designed to boost your productivity.
                    </p>
                </Modal.Body>

                <Modal.Footer className="border-0 d-flex flex-column gap-3 pt-0 mt-3 px-4">
                    <Button
                        variant="primary"
                        className="w-100 fw-semibold py-2 shadow-sm text-light"
                        onClick={() => navigate("/pricing")}
                        style={{
                            fontSize: "16px",
                            borderRadius: "8px",
                            height: 44,
                        }}
                    >
                        🌟 Go Premium
                    </Button>

                    <Button
                        variant="light"
                        className="w-100 py-2 fw-medium border"
                        onClick={onClose}
                        style={{
                            fontSize: "15px",
                            borderRadius: "8px",
                            height: 44,
                        }}
                    >
                        Maybe later
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
};
